import { render } from "./tutorial_preLogin.vue?vue&type=template&id=055870b0"
import script from "./tutorial_preLogin.vue?vue&type=script&lang=js"
export * from "./tutorial_preLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__